var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });

// src/chat-crypto/bytes.ts
var B64URL = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_";
function toBase64Url(bytes) {
  let out = "";
  let i = 0;
  for (; i + 2 < bytes.length; i += 3) {
    const n = bytes[i] << 16 | bytes[i + 1] << 8 | bytes[i + 2];
    out += B64URL[n >> 18] + B64URL[n >> 12 & 63] + B64URL[n >> 6 & 63] + B64URL[n & 63];
  }
  if (i < bytes.length) {
    const n = bytes[i] << 16 | (bytes[i + 1] ?? 0) << 8;
    out += B64URL[n >> 18] + B64URL[n >> 12 & 63];
    if (i + 1 < bytes.length) {
      out += B64URL[n >> 6 & 63];
    }
  }
  return out;
}
__name(toBase64Url, "toBase64Url");
function fromBase64Url(text) {
  const clean = text.replace(/=+$/, "");
  const out = [];
  let buffer = 0;
  let bits = 0;
  for (const ch of clean) {
    const v = B64URL.indexOf(ch);
    if (v < 0) {
      throw new Error("base64url \uD615\uC2DD\uC774 \uC544\uB2C8\uC5D0\uC694.");
    }
    buffer = buffer << 6 | v;
    bits += 6;
    if (bits >= 8) {
      bits -= 8;
      out.push(buffer >> bits & 255);
    }
  }
  return new Uint8Array(out);
}
__name(fromBase64Url, "fromBase64Url");
function utf8Encode(text) {
  return new TextEncoder().encode(text);
}
__name(utf8Encode, "utf8Encode");
function utf8Decode(bytes) {
  return new TextDecoder().decode(bytes);
}
__name(utf8Decode, "utf8Decode");
function concatBytes(...parts) {
  const total = parts.reduce((n, p) => n + p.length, 0);
  const out = new Uint8Array(total);
  let offset = 0;
  for (const p of parts) {
    out.set(p, offset);
    offset += p.length;
  }
  return out;
}
__name(concatBytes, "concatBytes");
function randomBytes(length) {
  const out = new Uint8Array(length);
  globalThis.crypto.getRandomValues(out);
  return out;
}
__name(randomBytes, "randomBytes");
var UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
function uuidToBytes(uuid) {
  if (!UUID_RE.test(uuid)) {
    throw new Error(`uuid \uD615\uC2DD\uC774 \uC544\uB2C8\uC5D0\uC694: ${uuid}`);
  }
  const hex = uuid.replace(/-/g, "").toLowerCase();
  const out = new Uint8Array(16);
  for (let i = 0; i < 16; i++) {
    out[i] = Number.parseInt(hex.slice(i * 2, i * 2 + 2), 16);
  }
  return out;
}
__name(uuidToBytes, "uuidToBytes");
function bytesToUuid(bytes) {
  if (bytes.length !== 16) {
    throw new Error("uuid \uB294 16\uBC14\uC774\uD2B8\uC5EC\uC57C \uD574\uC694.");
  }
  const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, "0")).join("");
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
__name(bytesToUuid, "bytesToUuid");
function bytesEqual(a, b) {
  if (a.length !== b.length) {
    return false;
  }
  let diff = 0;
  for (let i = 0; i < a.length; i++) {
    diff |= a[i] ^ b[i];
  }
  return diff === 0;
}
__name(bytesEqual, "bytesEqual");
function toHex(bytes) {
  return Array.from(bytes, (b) => b.toString(16).padStart(2, "0")).join("");
}
__name(toHex, "toHex");
function toArrayBuffer(bytes) {
  return bytes.slice().buffer;
}
__name(toArrayBuffer, "toArrayBuffer");

// src/chat-crypto/recovery-code.ts
var ALPHABET = "0123456789ABCDEFGHJKMNPQRSTVWXYZ";
var NORMALIZE = {
  O: "0",
  I: "1",
  L: "1",
  U: "V"
};
var RAW_BYTES = 16;
var DATA_CHARS = 26;
function encodeBase32(bytes) {
  let bits = 0;
  let buffer = 0;
  let out = "";
  for (const b of bytes) {
    buffer = buffer << 8 | b;
    bits += 8;
    while (bits >= 5) {
      bits -= 5;
      out += ALPHABET[buffer >> bits & 31];
    }
  }
  if (bits > 0) {
    out += ALPHABET[buffer << 5 - bits & 31];
  }
  return out;
}
__name(encodeBase32, "encodeBase32");
function decodeBase32(text, byteLength) {
  let bits = 0;
  let buffer = 0;
  const out = [];
  for (const ch of text) {
    const v = ALPHABET.indexOf(ch);
    if (v < 0) {
      throw new Error("\uBCF5\uAD6C \uCF54\uB4DC\uC5D0 \uC4F8 \uC218 \uC5C6\uB294 \uAE00\uC790\uAC00 \uC788\uC5B4\uC694.");
    }
    buffer = buffer << 5 | v;
    bits += 5;
    if (bits >= 8) {
      bits -= 8;
      out.push(buffer >> bits & 255);
    }
  }
  return new Uint8Array(out.slice(0, byteLength));
}
__name(decodeBase32, "decodeBase32");
function checksum(data) {
  let sum = 0;
  for (let i = 0; i < data.length; i++) {
    sum = (sum + ALPHABET.indexOf(data[i]) * (i + 1)) % 1024;
  }
  return ALPHABET[sum >> 5] + ALPHABET[sum & 31];
}
__name(checksum, "checksum");
function formatRecoveryCode(raw) {
  if (raw.length !== RAW_BYTES) {
    throw new Error("\uBCF5\uAD6C \uCF54\uB4DC\uB294 16\uBC14\uC774\uD2B8\uC5EC\uC57C \uD574\uC694.");
  }
  const data = encodeBase32(raw).slice(0, DATA_CHARS);
  const full = data + checksum(data);
  return full.match(/.{1,4}/g)?.join("-") ?? full;
}
__name(formatRecoveryCode, "formatRecoveryCode");
function generateRecoveryCode() {
  const raw = randomBytes(RAW_BYTES);
  return {
    raw,
    display: formatRecoveryCode(raw)
  };
}
__name(generateRecoveryCode, "generateRecoveryCode");
function parseRecoveryCode(input) {
  const text = input.toUpperCase().replace(/[\s-]/g, "").replace(/[OILU]/g, (c) => NORMALIZE[c] ?? c);
  if (text.length !== DATA_CHARS + 2) {
    throw new Error("\uBCF5\uAD6C \uCF54\uB4DC \uAE38\uC774\uAC00 \uB9DE\uC9C0 \uC54A\uC544\uC694.");
  }
  const data = text.slice(0, DATA_CHARS);
  if (checksum(data) !== text.slice(DATA_CHARS)) {
    throw new Error("\uBCF5\uAD6C \uCF54\uB4DC\uAC00 \uC62C\uBC14\uB974\uC9C0 \uC54A\uC544\uC694. \uB2E4\uC2DC \uD655\uC778\uD574 \uC8FC\uC138\uC694.");
  }
  return decodeBase32(data, RAW_BYTES);
}
__name(parseRecoveryCode, "parseRecoveryCode");

// src/chat-crypto/types.ts
var CHAT_CRYPTO_VERSION = 1;

// src/chat-crypto/index.ts
var EC = {
  name: "ECDH",
  namedCurve: "P-256"
};
var EC_SIGN = {
  name: "ECDSA",
  namedCurve: "P-256"
};
var RSA_OAEP = {
  name: "RSA-OAEP",
  hash: "SHA-256"
};
var AES_GCM_LEN = 256;
var IV_BYTES = 12;
var SALT_BYTES = 16;
var KEY_BYTES = 32;
var UUID_BYTES = 16;
var INFO_EPOCH = "hereby-chat/epoch-envelope/v1";
var INFO_DEVICE_LINK = "hereby-chat/device-link/v1";
var INFO_RECOVERY_HANDOFF = "hereby-chat/recovery-handoff/v1";
var INFO_ACCOUNT_BACKUP = "hereby-chat/account-backup/v1";
var ChatCryptoError = class extends Error {
  static {
    __name(this, "ChatCryptoError");
  }
  constructor(message) {
    super(message);
    this.name = "ChatCryptoError";
  }
};
function subtle() {
  const s = globalThis.crypto?.subtle;
  if (!s) {
    throw new ChatCryptoError("\uC774 \uD658\uACBD\uC5D0\uC11C\uB294 Web Crypto \uB97C \uC4F8 \uC218 \uC5C6\uC5B4\uC694.");
  }
  return s;
}
__name(subtle, "subtle");
async function sha256(bytes) {
  return new Uint8Array(await subtle().digest("SHA-256", toArrayBuffer(bytes)));
}
__name(sha256, "sha256");
async function sha256Hex(bytes) {
  return toHex(await sha256(bytes));
}
__name(sha256Hex, "sha256Hex");
async function generateAccountKeyPair() {
  const [ecdh, ecdsa] = await Promise.all([
    subtle().generateKey(EC, true, [
      "deriveBits"
    ]),
    subtle().generateKey(EC_SIGN, true, [
      "sign",
      "verify"
    ])
  ]);
  return {
    ecdh,
    ecdsa
  };
}
__name(generateAccountKeyPair, "generateAccountKeyPair");
async function exportAccountPublicKeys(pair) {
  const [ecdh, ecdsa] = await Promise.all([
    subtle().exportKey("spki", pair.ecdh.publicKey),
    subtle().exportKey("spki", pair.ecdsa.publicKey)
  ]);
  return {
    ecdhPublicKey: toBase64Url(new Uint8Array(ecdh)),
    ecdsaPublicKey: toBase64Url(new Uint8Array(ecdsa))
  };
}
__name(exportAccountPublicKeys, "exportAccountPublicKeys");
async function exportAccountPrivateBundle(pair) {
  const [pub, ecdhPriv, ecdsaPriv] = await Promise.all([
    exportAccountPublicKeys(pair),
    subtle().exportKey("pkcs8", pair.ecdh.privateKey),
    subtle().exportKey("pkcs8", pair.ecdsa.privateKey)
  ]);
  return {
    v: 1,
    ...pub,
    ecdhPrivateKey: toBase64Url(new Uint8Array(ecdhPriv)),
    ecdsaPrivateKey: toBase64Url(new Uint8Array(ecdsaPriv))
  };
}
__name(exportAccountPrivateBundle, "exportAccountPrivateBundle");
async function importAccountPrivateBundle(bundle) {
  if (bundle.v !== 1) {
    throw new ChatCryptoError("\uC9C0\uC6D0\uD558\uC9C0 \uC54A\uB294 \uACC4\uC815 \uD0A4 \uD615\uC2DD\uC774\uC5D0\uC694.");
  }
  const s = subtle();
  const [ecdhPrivateKey, ecdhPublicKey, ecdsaPrivateKey, ecdsaPublicKey] = await Promise.all([
    s.importKey("pkcs8", toArrayBuffer(fromBase64Url(bundle.ecdhPrivateKey)), EC, true, [
      "deriveBits"
    ]),
    importEcdhPublicKey(bundle.ecdhPublicKey),
    s.importKey("pkcs8", toArrayBuffer(fromBase64Url(bundle.ecdsaPrivateKey)), EC_SIGN, true, [
      "sign"
    ]),
    s.importKey("spki", toArrayBuffer(fromBase64Url(bundle.ecdsaPublicKey)), EC_SIGN, true, [
      "verify"
    ])
  ]);
  return {
    ecdh: {
      privateKey: ecdhPrivateKey,
      publicKey: ecdhPublicKey
    },
    ecdsa: {
      privateKey: ecdsaPrivateKey,
      publicKey: ecdsaPublicKey
    }
  };
}
__name(importAccountPrivateBundle, "importAccountPrivateBundle");
async function importEcdhPublicKey(spkiBase64Url) {
  return subtle().importKey("spki", toArrayBuffer(fromBase64Url(spkiBase64Url)), EC, true, []);
}
__name(importEcdhPublicKey, "importEcdhPublicKey");
async function fingerprintPublicKey(spkiBase64Url) {
  const hex = toHex(await sha256(fromBase64Url(spkiBase64Url))).slice(0, 40);
  return hex.match(/.{4}/g)?.join(" ") ?? hex;
}
__name(fingerprintPublicKey, "fingerprintPublicKey");
async function deriveWrapKey(sharedSecret, salt, info) {
  const s = subtle();
  const hkdfKey = await s.importKey("raw", toArrayBuffer(sharedSecret), "HKDF", false, [
    "deriveKey"
  ]);
  return s.deriveKey({
    name: "HKDF",
    hash: "SHA-256",
    salt: toArrayBuffer(salt),
    info: utf8Encode(info)
  }, hkdfKey, {
    name: "AES-GCM",
    length: AES_GCM_LEN
  }, false, [
    "encrypt",
    "decrypt"
  ]);
}
__name(deriveWrapKey, "deriveWrapKey");
async function sealToPublicKey(recipientSpkiBase64Url, plaintext, info, aad) {
  const s = subtle();
  const recipient = await importEcdhPublicKey(recipientSpkiBase64Url);
  const ephemeral = await s.generateKey(EC, true, [
    "deriveBits"
  ]);
  const shared = new Uint8Array(await s.deriveBits({
    name: "ECDH",
    public: recipient
  }, ephemeral.privateKey, 256));
  const salt = randomBytes(SALT_BYTES);
  const iv = randomBytes(IV_BYTES);
  const wrapKey = await deriveWrapKey(shared, salt, info);
  const ct = new Uint8Array(await s.encrypt({
    name: "AES-GCM",
    iv: toArrayBuffer(iv),
    additionalData: utf8Encode(aad)
  }, wrapKey, toArrayBuffer(plaintext)));
  const epk = new Uint8Array(await s.exportKey("raw", ephemeral.publicKey));
  return {
    v: 1,
    alg: "ECIES-P256-HKDF-A256GCM",
    epk: toBase64Url(epk),
    salt: toBase64Url(salt),
    iv: toBase64Url(iv),
    ct: toBase64Url(ct)
  };
}
__name(sealToPublicKey, "sealToPublicKey");
async function openWithPrivateKey(recipientEcdhPrivateKey, envelope, info, aad) {
  if (envelope.v !== 1 || envelope.alg !== "ECIES-P256-HKDF-A256GCM") {
    throw new ChatCryptoError("\uC9C0\uC6D0\uD558\uC9C0 \uC54A\uB294 \uBD09\uD22C \uD615\uC2DD\uC774\uC5D0\uC694.");
  }
  const s = subtle();
  const epk = await s.importKey("raw", toArrayBuffer(fromBase64Url(envelope.epk)), EC, true, []);
  const shared = new Uint8Array(await s.deriveBits({
    name: "ECDH",
    public: epk
  }, recipientEcdhPrivateKey, 256));
  const wrapKey = await deriveWrapKey(shared, fromBase64Url(envelope.salt), info);
  try {
    return new Uint8Array(await s.decrypt({
      name: "AES-GCM",
      iv: toArrayBuffer(fromBase64Url(envelope.iv)),
      additionalData: utf8Encode(aad)
    }, wrapKey, toArrayBuffer(fromBase64Url(envelope.ct))));
  } catch {
    throw new ChatCryptoError("\uBD09\uD22C\uB97C \uC5F4 \uC218 \uC5C6\uC5B4\uC694. \uD0A4\uB098 \uB300\uC0C1\uC774 \uB9DE\uC9C0 \uC54A\uC544\uC694.");
  }
}
__name(openWithPrivateKey, "openWithPrivateKey");
function generateRoomKey() {
  return randomBytes(KEY_BYTES);
}
__name(generateRoomKey, "generateRoomKey");
async function importRoomKey(raw, extractable = false) {
  if (raw.length !== KEY_BYTES) {
    throw new ChatCryptoError("\uBC29 \uD0A4\uB294 32\uBC14\uC774\uD2B8\uC5EC\uC57C \uD574\uC694.");
  }
  return subtle().importKey("raw", toArrayBuffer(raw), "AES-KW", extractable, [
    "wrapKey",
    "unwrapKey"
  ]);
}
__name(importRoomKey, "importRoomKey");
function buildEpochHeader(h) {
  return `${h.organizationId}.${h.conversationId}.${h.epoch}.${h.recipientEmployeeId}.${h.recipientKeyVersion}`;
}
__name(buildEpochHeader, "buildEpochHeader");
async function sealEpochEnvelope(params) {
  if (params.roomKey.length !== KEY_BYTES) {
    throw new ChatCryptoError("\uBC29 \uD0A4\uB294 32\uBC14\uC774\uD2B8\uC5EC\uC57C \uD574\uC694.");
  }
  return sealToPublicKey(params.recipientEcdhPublicKey, params.roomKey, INFO_EPOCH, buildEpochHeader(params.header));
}
__name(sealEpochEnvelope, "sealEpochEnvelope");
async function openEpochEnvelope(params) {
  const raw = await openWithPrivateKey(params.recipientEcdhPrivateKey, params.envelope, INFO_EPOCH, buildEpochHeader(params.header));
  if (raw.length !== KEY_BYTES) {
    throw new ChatCryptoError("\uBD09\uD22C \uC548\uC758 \uBC29 \uD0A4 \uAE38\uC774\uAC00 \uB9DE\uC9C0 \uC54A\uC544\uC694.");
  }
  return raw;
}
__name(openEpochEnvelope, "openEpochEnvelope");
function generateMessageKey() {
  return randomBytes(KEY_BYTES);
}
__name(generateMessageKey, "generateMessageKey");
async function importMessageKey(raw, extractable = false) {
  if (raw.length !== KEY_BYTES) {
    throw new ChatCryptoError("\uBA54\uC2DC\uC9C0 \uD0A4\uB294 32\uBC14\uC774\uD2B8\uC5EC\uC57C \uD574\uC694.");
  }
  return subtle().importKey("raw", toArrayBuffer(raw), {
    name: "AES-GCM"
  }, extractable, [
    "encrypt",
    "decrypt"
  ]);
}
__name(importMessageKey, "importMessageKey");
async function wrapMessageKey(roomKey, messageKey) {
  const mk = await importMessageKey(messageKey, true);
  const wrapped = await subtle().wrapKey("raw", mk, roomKey, "AES-KW");
  return toBase64Url(new Uint8Array(wrapped));
}
__name(wrapMessageKey, "wrapMessageKey");
async function unwrapMessageKey(roomKey, keyWrap) {
  try {
    return await subtle().unwrapKey("raw", toArrayBuffer(fromBase64Url(keyWrap)), roomKey, "AES-KW", {
      name: "AES-GCM"
    }, false, [
      "encrypt",
      "decrypt"
    ]);
  } catch {
    throw new ChatCryptoError("\uBA54\uC2DC\uC9C0 \uD0A4\uB97C \uD480 \uC218 \uC5C6\uC5B4\uC694. \uC138\uB300 \uD0A4\uAC00 \uB9DE\uC9C0 \uC54A\uC544\uC694.");
  }
}
__name(unwrapMessageKey, "unwrapMessageKey");
function buildMessageAad(p) {
  return `${p.organizationId}.${p.conversationId}.${p.senderId}.${p.messageId}.${p.keyEpoch}.v1`;
}
__name(buildMessageAad, "buildMessageAad");
async function encryptMessage(messageKey, payload, aad) {
  const key = messageKey instanceof Uint8Array ? await importMessageKey(messageKey) : messageKey;
  const iv = randomBytes(IV_BYTES);
  const ct = new Uint8Array(await subtle().encrypt({
    name: "AES-GCM",
    iv: toArrayBuffer(iv),
    additionalData: utf8Encode(aad)
  }, key, toArrayBuffer(utf8Encode(JSON.stringify(payload)))));
  return toBase64Url(concatBytes(iv, ct));
}
__name(encryptMessage, "encryptMessage");
async function decryptMessage(messageKey, ciphertext, aad) {
  const key = messageKey instanceof Uint8Array ? await importMessageKey(messageKey) : messageKey;
  const bytes = fromBase64Url(ciphertext);
  if (bytes.length <= IV_BYTES) {
    throw new ChatCryptoError("\uC554\uD638\uBB38\uC774 \uB108\uBB34 \uC9E7\uC544\uC694.");
  }
  try {
    const plain = await subtle().decrypt({
      name: "AES-GCM",
      iv: toArrayBuffer(bytes.subarray(0, IV_BYTES)),
      additionalData: utf8Encode(aad)
    }, key, toArrayBuffer(bytes.subarray(IV_BYTES)));
    return JSON.parse(utf8Decode(new Uint8Array(plain)));
  } catch {
    throw new ChatCryptoError("\uBA54\uC2DC\uC9C0\uB97C \uD480 \uC218 \uC5C6\uC5B4\uC694. \uD0A4\uB098 \uBA54\uC2DC\uC9C0 \uC815\uBCF4\uAC00 \uB9DE\uC9C0 \uC54A\uC544\uC694.");
  }
}
__name(decryptMessage, "decryptMessage");
async function importRecoveryPublicKey(spkiBase64Url) {
  return subtle().importKey("spki", toArrayBuffer(fromBase64Url(spkiBase64Url)), RSA_OAEP, false, [
    "encrypt"
  ]);
}
__name(importRecoveryPublicKey, "importRecoveryPublicKey");
async function importRecoveryPrivateKey(pkcs8Base64Url) {
  return subtle().importKey("pkcs8", toArrayBuffer(fromBase64Url(pkcs8Base64Url)), RSA_OAEP, false, [
    "decrypt"
  ]);
}
__name(importRecoveryPrivateKey, "importRecoveryPrivateKey");
function buildRecoveryPlaintext(messageKey, binding) {
  if (messageKey.length !== KEY_BYTES) {
    throw new ChatCryptoError("\uBA54\uC2DC\uC9C0 \uD0A4\uB294 32\uBC14\uC774\uD2B8\uC5EC\uC57C \uD574\uC694.");
  }
  return concatBytes(messageKey, uuidToBytes(binding.organizationId), uuidToBytes(binding.conversationId), uuidToBytes(binding.messageId));
}
__name(buildRecoveryPlaintext, "buildRecoveryPlaintext");
function parseRecoveryPlaintext(bytes) {
  if (bytes.length !== KEY_BYTES + UUID_BYTES * 3) {
    throw new ChatCryptoError("\uBCF5\uAD6C \uBD09\uD22C \uD3C9\uBB38 \uAE38\uC774\uAC00 \uB9DE\uC9C0 \uC54A\uC544\uC694.");
  }
  const at = /* @__PURE__ */ __name((start, len) => bytes.subarray(start, start + len), "at");
  return {
    messageKey: new Uint8Array(at(0, KEY_BYTES)),
    organizationId: bytesToUuid(at(KEY_BYTES, UUID_BYTES)),
    conversationId: bytesToUuid(at(KEY_BYTES + UUID_BYTES, UUID_BYTES)),
    messageId: bytesToUuid(at(KEY_BYTES + UUID_BYTES * 2, UUID_BYTES))
  };
}
__name(parseRecoveryPlaintext, "parseRecoveryPlaintext");
async function sealRecoveryEnvelope(params) {
  const ct = new Uint8Array(await subtle().encrypt({
    name: "RSA-OAEP"
  }, params.recoveryPublicKey, toArrayBuffer(buildRecoveryPlaintext(params.messageKey, params.binding))));
  return {
    v: 1,
    alg: "RSA-OAEP-256",
    kid: params.keyId,
    ct: toBase64Url(ct)
  };
}
__name(sealRecoveryEnvelope, "sealRecoveryEnvelope");
async function openRecoveryEnvelope(params) {
  if (params.envelope.v !== 1 || params.envelope.alg !== "RSA-OAEP-256") {
    throw new ChatCryptoError("\uC9C0\uC6D0\uD558\uC9C0 \uC54A\uB294 \uBCF5\uAD6C \uBD09\uD22C \uD615\uC2DD\uC774\uC5D0\uC694.");
  }
  let plain;
  try {
    plain = await subtle().decrypt({
      name: "RSA-OAEP"
    }, params.recoveryPrivateKey, toArrayBuffer(fromBase64Url(params.envelope.ct)));
  } catch {
    throw new ChatCryptoError("\uBCF5\uAD6C \uBD09\uD22C\uB97C \uC5F4 \uC218 \uC5C6\uC5B4\uC694.");
  }
  return parseRecoveryPlaintext(new Uint8Array(plain));
}
__name(openRecoveryEnvelope, "openRecoveryEnvelope");
function recoveryBindingMatches(plain, expected) {
  return bytesEqual(uuidToBytes(plain.organizationId), uuidToBytes(expected.organizationId)) && bytesEqual(uuidToBytes(plain.conversationId), uuidToBytes(expected.conversationId)) && bytesEqual(uuidToBytes(plain.messageId), uuidToBytes(expected.messageId));
}
__name(recoveryBindingMatches, "recoveryBindingMatches");
async function encryptFile(bytes) {
  const key = randomBytes(KEY_BYTES);
  const iv = randomBytes(IV_BYTES);
  const k = await importMessageKey(key);
  const ciphertext = new Uint8Array(await subtle().encrypt({
    name: "AES-GCM",
    iv: toArrayBuffer(iv)
  }, k, toArrayBuffer(bytes)));
  return {
    key,
    iv: toBase64Url(iv),
    ciphertext
  };
}
__name(encryptFile, "encryptFile");
async function decryptFile(file) {
  const k = await importMessageKey(file.key);
  try {
    return new Uint8Array(await subtle().decrypt({
      name: "AES-GCM",
      iv: toArrayBuffer(fromBase64Url(file.iv))
    }, k, toArrayBuffer(file.ciphertext)));
  } catch {
    throw new ChatCryptoError("\uD30C\uC77C\uC744 \uD480 \uC218 \uC5C6\uC5B4\uC694.");
  }
}
__name(decryptFile, "decryptFile");
async function backupKey(recoveryCode, salt) {
  if (recoveryCode.length !== 16) {
    throw new ChatCryptoError("\uBCF5\uAD6C \uCF54\uB4DC\uB294 16\uBC14\uC774\uD2B8\uC5EC\uC57C \uD574\uC694.");
  }
  return deriveWrapKey(recoveryCode, salt, INFO_ACCOUNT_BACKUP);
}
__name(backupKey, "backupKey");
async function sealAccountBackup(recoveryCode, bundle) {
  const salt = randomBytes(SALT_BYTES);
  const iv = randomBytes(IV_BYTES);
  const key = await backupKey(recoveryCode, salt);
  const ct = new Uint8Array(await subtle().encrypt({
    name: "AES-GCM",
    iv: toArrayBuffer(iv),
    additionalData: utf8Encode(INFO_ACCOUNT_BACKUP)
  }, key, toArrayBuffer(utf8Encode(JSON.stringify(bundle)))));
  return {
    v: 1,
    alg: "HKDF-A256GCM",
    salt: toBase64Url(salt),
    iv: toBase64Url(iv),
    ct: toBase64Url(ct)
  };
}
__name(sealAccountBackup, "sealAccountBackup");
async function openAccountBackup(recoveryCode, backup) {
  if (backup.v !== 1 || backup.alg !== "HKDF-A256GCM") {
    throw new ChatCryptoError("\uC9C0\uC6D0\uD558\uC9C0 \uC54A\uB294 \uBC31\uC5C5 \uD615\uC2DD\uC774\uC5D0\uC694.");
  }
  const key = await backupKey(recoveryCode, fromBase64Url(backup.salt));
  try {
    const plain = await subtle().decrypt({
      name: "AES-GCM",
      iv: toArrayBuffer(fromBase64Url(backup.iv)),
      additionalData: utf8Encode(INFO_ACCOUNT_BACKUP)
    }, key, toArrayBuffer(fromBase64Url(backup.ct)));
    return JSON.parse(utf8Decode(new Uint8Array(plain)));
  } catch {
    throw new ChatCryptoError("\uBCF5\uAD6C \uCF54\uB4DC\uAC00 \uB9DE\uC9C0 \uC54A\uC544\uC694.");
  }
}
__name(openAccountBackup, "openAccountBackup");
async function generateDeviceLinkKeyPair() {
  return subtle().generateKey(EC, true, [
    "deriveBits"
  ]);
}
__name(generateDeviceLinkKeyPair, "generateDeviceLinkKeyPair");
async function exportPublicKeySpki(key) {
  return toBase64Url(new Uint8Array(await subtle().exportKey("spki", key)));
}
__name(exportPublicKeySpki, "exportPublicKeySpki");
async function deviceLinkCode(ephemeralSpkiBase64Url) {
  const digest = await sha256(fromBase64Url(ephemeralSpkiBase64Url));
  const n = (digest[0] << 12 | digest[1] << 4 | digest[2] >> 4) % 1e6;
  return n.toString().padStart(6, "0");
}
__name(deviceLinkCode, "deviceLinkCode");
async function sealDeviceLinkPayload(params) {
  return sealToPublicKey(params.ephemeralPublicKey, utf8Encode(JSON.stringify(params.bundle)), INFO_DEVICE_LINK, params.requestId);
}
__name(sealDeviceLinkPayload, "sealDeviceLinkPayload");
async function openDeviceLinkPayload(params) {
  const plain = await openWithPrivateKey(params.ephemeralPrivateKey, params.payload, INFO_DEVICE_LINK, params.requestId);
  return JSON.parse(utf8Decode(plain));
}
__name(openDeviceLinkPayload, "openDeviceLinkPayload");
async function sealRecoveryHandoff(params) {
  const body = params.messageKeys.map((k) => ({
    messageId: k.messageId,
    key: toBase64Url(k.key)
  }));
  return sealToPublicKey(params.recipientPublicKey, utf8Encode(JSON.stringify(body)), INFO_RECOVERY_HANDOFF, params.requestId);
}
__name(sealRecoveryHandoff, "sealRecoveryHandoff");
async function openRecoveryHandoff(params) {
  const plain = await openWithPrivateKey(params.recipientPrivateKey, params.envelope, INFO_RECOVERY_HANDOFF, params.requestId);
  const body = JSON.parse(utf8Decode(plain));
  return body.map((k) => ({
    messageId: k.messageId,
    key: fromBase64Url(k.key)
  }));
}
__name(openRecoveryHandoff, "openRecoveryHandoff");
var SIGN_ALG = {
  name: "ECDSA",
  hash: "SHA-256"
};
var EPOCH_ATTESTATION_PREFIX = "hereby-chat/epoch-attestation/v1";
var MEMBERSHIP_ATTESTATION_PREFIX = "hereby-chat/membership-attestation/v1";
async function importEcdsaPublicKey(spkiBase64Url) {
  return subtle().importKey("spki", toArrayBuffer(fromBase64Url(spkiBase64Url)), EC_SIGN, true, [
    "verify"
  ]);
}
__name(importEcdsaPublicKey, "importEcdsaPublicKey");
async function signBytes(ecdsaPrivateKey, bytes) {
  return toBase64Url(new Uint8Array(await subtle().sign(SIGN_ALG, ecdsaPrivateKey, toArrayBuffer(bytes))));
}
__name(signBytes, "signBytes");
async function verifyBytes(ecdsaPublicKeySpki, bytes, signatureBase64Url) {
  try {
    const key = await importEcdsaPublicKey(ecdsaPublicKeySpki);
    return await subtle().verify(SIGN_ALG, key, toArrayBuffer(fromBase64Url(signatureBase64Url)), toArrayBuffer(bytes));
  } catch {
    return false;
  }
}
__name(verifyBytes, "verifyBytes");
async function roomKeyCommitment(roomKey) {
  return sha256Hex(roomKey);
}
__name(roomKeyCommitment, "roomKeyCommitment");
function buildEpochAttestationBytes(p) {
  return utf8Encode([
    EPOCH_ATTESTATION_PREFIX,
    p.organizationId,
    p.conversationId,
    String(p.epoch),
    p.reason,
    p.keyCommitment
  ].join("\n"));
}
__name(buildEpochAttestationBytes, "buildEpochAttestationBytes");
function buildMembershipAttestationBytes(p) {
  return utf8Encode([
    MEMBERSHIP_ATTESTATION_PREFIX,
    p.organizationId,
    p.conversationId ?? "",
    p.action,
    [
      ...p.employeeIds
    ].sort().join(","),
    p.at
  ].join("\n"));
}
__name(buildMembershipAttestationBytes, "buildMembershipAttestationBytes");
async function safetyNumber(ecdhPublicKeyA, ecdhPublicKeyB) {
  const [first, second] = [
    ecdhPublicKeyA,
    ecdhPublicKeyB
  ].sort();
  const digest = await sha256(concatBytes(utf8Encode("hereby-chat/safety-number/v1"), fromBase64Url(first), fromBase64Url(second)));
  const groups = [];
  for (let i = 0; i < 12; i++) {
    let n = 0;
    for (let j = 0; j < 5; j++) {
      n = (n * 256 + digest[(i * 5 + j) % digest.length]) % 1e5;
    }
    groups.push(String(n).padStart(5, "0"));
  }
  return groups.join(" ");
}
__name(safetyNumber, "safetyNumber");
export {
  CHAT_CRYPTO_VERSION,
  ChatCryptoError,
  buildEpochAttestationBytes,
  buildEpochHeader,
  buildMembershipAttestationBytes,
  buildMessageAad,
  buildRecoveryPlaintext,
  bytesEqual,
  bytesToUuid,
  concatBytes,
  decryptFile,
  decryptMessage,
  deviceLinkCode,
  encryptFile,
  encryptMessage,
  exportAccountPrivateBundle,
  exportAccountPublicKeys,
  exportPublicKeySpki,
  fingerprintPublicKey,
  formatRecoveryCode,
  fromBase64Url,
  generateAccountKeyPair,
  generateDeviceLinkKeyPair,
  generateMessageKey,
  generateRecoveryCode,
  generateRoomKey,
  importAccountPrivateBundle,
  importEcdhPublicKey,
  importEcdsaPublicKey,
  importMessageKey,
  importRecoveryPrivateKey,
  importRecoveryPublicKey,
  importRoomKey,
  openAccountBackup,
  openDeviceLinkPayload,
  openEpochEnvelope,
  openRecoveryEnvelope,
  openRecoveryHandoff,
  openWithPrivateKey,
  parseRecoveryCode,
  parseRecoveryPlaintext,
  randomBytes,
  recoveryBindingMatches,
  roomKeyCommitment,
  safetyNumber,
  sealAccountBackup,
  sealDeviceLinkPayload,
  sealEpochEnvelope,
  sealRecoveryEnvelope,
  sealRecoveryHandoff,
  sealToPublicKey,
  sha256Hex,
  signBytes,
  toArrayBuffer,
  toBase64Url,
  toHex,
  unwrapMessageKey,
  utf8Decode,
  utf8Encode,
  uuidToBytes,
  verifyBytes,
  wrapMessageKey
};
//# sourceMappingURL=chat-crypto.mjs.map